import { motion } from "framer-motion";
import { fadeUp } from "@/lib/site";

// Scroll-triggered reveal wrapper.
export default function Reveal({ children, i = 0, className = "", as = "div", amount = 0.3 }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount }}
    >
      {children}
    </MotionTag>
  );
}
